import React from 'react';
import { RhNumberField } from '../../../../../../../../dum';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import {
    GROUP_PRICE,
    KILO_PRICE,
    ORDER_SALE_PRODUCTS,
} from '../order-sale-products-columns';
import { useFormContext, useWatch } from 'react-hook-form';
import { IOrderSale } from '../../../order-sale-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ORDER_REQUEST_NAME: keyof IOrderSale = 'order_request';

export function GroupPriceInput({ index }: { index: number }) {
    const INPUT_NAME = `${ORDER_SALE_PRODUCTS}.${index}.${GROUP_PRICE}`;
    const { calculateProductsTotal } = useCalculateProductsTotal();
    const rx = useFormContext();
    const kiloPrice = useWatch({
        name: `${ORDER_SALE_PRODUCTS}.${index}.${KILO_PRICE}`,
    }) as IOrderSale['order_sale_products'][number]['kilo_price'];
    // When the sale is linked to an order request, the price is pinned to the
    // request and locked. Otherwise keep the kilo/group mutual-exclusivity lock.
    const orderRequest = useWatch({
        name: ORDER_REQUEST_NAME,
    }) as IOrderSale['order_request'];

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.group_price)}
            disabled={!!orderRequest || Number(kiloPrice) !== 0}
            disableGutters
            onChange={() => {
                calculateProductsTotal({ index });
                void rx.trigger(
                    `${ORDER_SALE_PRODUCTS}.${index}.${KILO_PRICE}`,
                );
            }}
        />
    );
}
